// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"ProductsPrefferenceModal_modalContainer__rNX2e","modalContent":"ProductsPrefferenceModal_modalContent__swQxi"};